import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgIf } from "@angular/common";
import { PropertyStatusDirective } from "@common/directive/property-status.directive";
import { ResourceByIdPipe } from "@shared/pipes/resource-by-id.pipe";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { ModalService } from '@shared/services/modal/modal.service';
import { ApartmentsService } from '@modules/universal-billing/apartments/apartments.service';
import {CardComponent} from '@modules/dashboard/card/card.component';
import { ApartmentUnitStatusDirective } from '@common/directive/apartment-unit-status.directive';

@Component({
  selector: 'apartment-card',
  standalone: true,
  imports: [
    NgIf,
    PropertyStatusDirective,
    ResourceByIdPipe,
    TranslatePipe,
    CardComponent,
    ApartmentUnitStatusDirective
  ],
  templateUrl: './apartment-card.component.html',
  styleUrl: './apartment-card.component.scss'
})
export class ApartmentCardComponent {
  @Input() apartment: Apartment;
  @Output() edit = new EventEmitter();

  protected modalService = inject(ModalService);
  protected translateService = inject(TranslateService);
  protected service = inject(ApartmentsService);

  onEdit() {
    this.modalService.open({
      component: this.service.formComponent,
      title: 'APARTMENT.EDIT_APARTMENT',
      componentOptions: {
        selectedRow: this.apartment,
        isEdit: true,
        _defaultService: this.service
      },
      modalOptions: this.service?.formModalOptions ?? {}
    }).then((res) => {
      if (res == ModalClose.SUCCESS) {
        this.edit.next(null);
      }
    }).catch((err) => {})
  }
}
